if (typeof customElements.get('case-progress') === 'undefined') {

  class CaseProgress extends HTMLElement {

    connectedCallback() {
      const count = parseInt(this.getAttribute('data-bottle-count') || '0');

      if (count === 0) {
        this.innerHTML = '';
        return;
      }

      if (count < 12) {
        const needed = 12 - count;
        const word = needed === 1 ? 'bottle' : 'bottles';
              this.innerHTML = `<div class="case-progress case-progress--warning">You’re ${needed} ${word} away from case pricing! Mix &amp; match any bottles to unlock savings across your entire order.</div>`;
      } else {
        this.innerHTML = `<div class="case-progress case-progress--success">Wholesale pricing applied — all bottles are at case price.</div>`;
      }
    }

  }

  customElements.define('case-progress', CaseProgress);

}
